module.exports = new __parcel__URL__("stoomboot-210bpm.fc071f2f.mp3").toString();